import React, { ReactNode, useState,createContext,useContext } from 'react'

interface ResultTableContextProps {
  resultRow: number;
  setAnalytic: (inp: number) => void;
  getAnalytic: (inp: number) => boolean;
  setWidthRow: (inp: number) => void;
  getWidthRow: () => number;
}

const ResultTableContext = createContext<ResultTableContextProps | undefined>(undefined);

type ResultTableContextRef = {children: ReactNode}

export const ResultTableProvider:React.FC<ResultTableContextRef> = ({children}) => {
  const [resultRow,setResultRow] = useState<number>(-1);
  const [widthRow,setWidthRow] = useState<number>(0);
  
  const setAnalytic = (inp:number) => {
    setResultRow(inp);
  }
  const getAnalytic = (inp:number):boolean => {
    return inp === resultRow ? true : false;
  }

  const getWidthRow = ():number => {
    return widthRow - 10;
  }
  
  return (
    <ResultTableContext.Provider
      value={{
        resultRow,
        setAnalytic,
        getAnalytic,
        setWidthRow,
        getWidthRow
      }}
    >
      {children}
    </ResultTableContext.Provider>
  );
}

export const useResultTable = (): ResultTableContextProps => {
  const context = useContext(ResultTableContext);
  if (!context) {
    throw new Error("useClock must be used within a ClockProvider");
  }
  return context;
};